<template>
  <EuiContainer>
    <EuiGrid class="mx-0 mt-2">
      <searchCard
          title="Mise à jour du genre"
          @reset-field="resetModifiedField"/>
      <EuiGridRow v-if="getterIsLaunch " class="mt-4">
        <EuiBlock title="Résultat">
          <template v-slot:actions>
            <form v-if="getterResult.length === 1" @submit.prevent="validation">
              <EuiGridRow class="my-2" justify="between">
                <EuiGridColumn class="mx-6 w-64">
                  <EuiTextField
                      :value="getterResult[0].gender"
                      adaptSize
                      disabled
                      label="Genre actuel"/>
                </EuiGridColumn>
                <EuiGridColumn class="mx-6 w-64">
                  <EuiTextField adaptSize>
                    <EuiLabel>Genre modifié</EuiLabel>
                    <EuiSelect id="modifiedGender" v-model="modifiedGender">
                      <Option
                          v-for="gender in getterListGender"
                          :key="gender.key"
                          :value="gender.key">
                        {{ gender.key }}
                      </Option>
                    </EuiSelect>
                  </EuiTextField>
                </EuiGridColumn>
                <EuiGridColumn class="ml-2">
                  <EuiButton
                      class="ml-auto mr-2 my-auto"
                      color="primary"
                      variant="raised"
                      type="submit"
                      :disabled="!isEnabledDialog">
                    Valider
                  </EuiButton>
                </EuiGridColumn>
              </EuiGridRow>
            </form>
          </template>
          <resultCard />
        </EuiBlock>
      </EuiGridRow>
    </EuiGrid>
    <ConfirmationDialog
        v-if="isEnabledDialog"
        :isOpen="isConfirmationDialogOpen"
        @confirmation="confirmation"
        @close-dialog="closeDialog">
      <span v-html="confirmationMessage"></span>
    </ConfirmationDialog>
  </EuiContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import searchCard from '@/components/searchCard.vue';
import resultCard from '@/components/resultCard.vue';
import ConfirmationDialog from '@/components/confirmationDialog.vue';
import { HTTP_CONFIG } from '@/http';

export default {
  name: 'pages.update.gender',
  components: {
    searchCard,
    resultCard,
    ConfirmationDialog,
  },
  data() {
    return {
      HTTP_CONFIG,
      modifiedGender: 'Monsieur',
      isConfirmationDialogOpen: false,
      isUpdatedBoxe: false,
    };
  },
  mounted() {
    this.storeResetChangeRoute();
  },
  computed: {
    ...mapGetters({
      getterIsLaunch: 'application/isLaunch',
      getterResult: 'boxes/result',
      getterSession: 'auth/session',
      getterListGender: 'application/listGender',
    }),
    isEnabledDialog() {
      return this.getterResult.length === 1 && this.modifiedGender !== this.getterResult[0].gender;
    },
    confirmationMessage() {
      return 'Confirmation du changement:<br>'
        + `genre <b>${this.getterResult[0].gender}</b> `
        + `vers <b>${this.modifiedGender}</b><br>`
        + `pour le coffre ayant pour userId = <b>${this.getterResult[0].userId}</b> ?`;
    },
  },
  methods: {
    ...mapActions({
      storeResetChangeRoute: 'application/resetChangeRoute',
      storeUpdateGender: 'boxes/updateGender',
      storeSearchMatches: 'boxes/getMatchesBoxes',
      storeStartLoading: 'application/startLoading',
      storeFinishLoading: 'application/finishLoading',
    }),
    closeDialog() {
      this.isConfirmationDialogOpen = false;
    },
    explicitGender(index = 1) {
      return this.getterListGender[index - 1];
    },
    confirmation() {
      this.closeDialog();
      this.storeStartLoading();
      this.storeUpdateGender({
        sessionId: this.getterSession.token,
        userId: this.getterResult[0].userId,
        gender: this.getterListGender.find(
          el => (el.key === this.modifiedGender),
        )[this.HTTP_CONFIG.backOfficeVersion],
      }).then(() => {
        this.modifiedGender = 'Monsieur';
        this.storeSearchMatches({
          userId: this.getterResult[0].userId,
          sessionId: this.getterSession.token,
        }).then(() => {
          this.isUpdatedBoxe = true;
          this.storeFinishLoading();
        });
      }).catch(() => {
        this.storeFinishLoading();
      });
    },
    validation() {
      this.isConfirmationDialogOpen = true;
    },
    resetModifiedField() {
      this.modifiedGender = 'Monsieur';
      this.isUpdatedBoxe = false;
    },
  },
};
</script>
